import { useState } from "react";
import { api } from "../api";
import { useAuth } from "../auth";
import { errorMessage } from "./AuthCard";

const DISMISS_KEY = "verify-banner-dismissed";

function dismissedFor(userId: number): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === String(userId);
  } catch {
    return false;
  }
}

/** Gentle nudge for unverified accounts: nothing is locked, it just asks. Hidden for this tab once dismissed. */
export function VerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => (user ? dismissedFor(user.id) : false));
  const [status, setStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  async function resend() {
    setBusy(true);
    try {
      setStatus((await api.resendVerification()).message);
    } catch (err) {
      setStatus(errorMessage(err, "We couldn't send the email. Try again later."));
    } finally {
      setBusy(false);
    }
  }

  function dismiss() {
    try {
      sessionStorage.setItem(DISMISS_KEY, String(user!.id));
    } catch {
      /* storage unavailable: hide for now anyway */
    }
    setDismissed(true);
  }

  return (
    <div className="verify-banner" role="status">
      <span className="verify-text">
        {status ?? (
          <>
            Please verify your email soon. We sent a link to <strong>{user.email}</strong>.
          </>
        )}
      </span>
      {!status && (
        <button className="link-btn" onClick={() => void resend()} disabled={busy}>
          {busy ? "Sending…" : "Resend email"}
        </button>
      )}
      <button className="verify-close" onClick={dismiss} aria-label="Dismiss until next visit">
        ×
      </button>
    </div>
  );
}
